
export const toDataURL = (url: string) => {
    return fetch(url).then((response) => {
        return response.blob();
    }).then(blob => {
        return URL.createObjectURL(blob);
    });
}


  // Set up download links 
  const downloadLinks = document.querySelectorAll<HTMLAnchorElement>('a.download-link');
  [...downloadLinks].forEach(async dl => {
    try {
      const dataURL = await toDataURL(dl.href);
      dl.href = dataURL;
    } catch (e){
      console.error(e);
    }
  })